import React, {useEffect, useRef, useState} from 'react';
import {useSearchParams} from "react-router";
import ReportUtils from "../../../utils/report-utils.js";
import axios from "axios";
import SubScroll from "../../../components/sub-scroll/sub-scroll.jsx";
import {Template} from "../../../components/template/template.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import {Card} from "../../../components/card/card.jsx";
import Content from "./components/content.jsx";
const API_URL = import.meta.env.VITE_API_URL;

const OccurrencePrint = () => {
    const [loading, setLoading] = useState(false);
    const [title] = useState("Ocorrência");
    const [reportData, setReportData] = useState(null);
    const [headerSelected, setHeaderSelected] = useState(-1);
    const [reportDataLength, setReportDataLength] = useState(0)
    const [searchParams] = useSearchParams();

    useEffect(() => {
        apply(searchParams.get("occurrenceid"))
    }, []);

    const apply = async (occurrence) => {
        ReportUtils.applyLoad({
            setLoading,
            clearContent: () => {
                setReportData(null)
            }
        });

        try {
            const { data: response } = await axios.post(API_URL + "/reports/occurrence_print/apply", {occurrenceid: occurrence});

            const data = response;
            setReportData(data);

            if (data.id) setReportDataLength(data.id.length)

        } catch (error) {

            ReportUtils.alertErrorMessage("Erro ao gerar o relatório.");
            console.error("Erro ao gerar o relatório", error);

        } finally {
            setLoading(false);
        }
    };

    const printComponentRef = useRef(null);

    return (
        <SubScroll dependency={[reportData]}>
            <Template isLoading={loading}>
                <Template.Header>
                    <Template.Title>{title} {reportData?.data?.id ? `${reportData?.data?.id}` : ""}</Template.Title>
                    <HeaderButtons
                        exportable={false}
                        exportInSheets={false}
                        printable={true}
                        headerChange={true}
                        printComponentRef={printComponentRef}
                        reportData={reportData}
                        data={reportDataLength}
                        headerSelected={headerSelected}
                        setHeaderSelected={setHeaderSelected}
                    />
                </Template.Header>
                <Template.Body className="pl-0!">
                    <Card className="w-full max-w-[1030px] mx-auto p-[0]!">
                        <Card.Body>
                            <Content
                                reportData={reportData}
                                data={reportDataLength}
                                entity={headerSelected}
                                title={title}
                                setLoading={setLoading}
                                printComponentRef={printComponentRef}
                            />
                        </Card.Body>
                    </Card>
                </Template.Body>
            </Template>
        </SubScroll>
    );
};

export default OccurrencePrint;